import firebase from 'firebase'
import Fuse from 'fuse-js-latest'
import * as d3 from 'd3'

export default {
    state: {     
    isSyncedFundraiser:false, 
    listFundraiserTypes: null,


    fundraiserPayments: null,
    fundraiserPaymentsGroupedByYearLine: null,
    fundraiserPaymentsGroupedByYearMonth: null,
    fundraiserMemberPayments: null,
    fundraiserLinePayments: null,
    fundraiserTechassessmentSubscriptionStatus: null,
/*
    endowmentFundraiserPayments: [],
    endowmentFundraiserPaymentsGroupedByYearLine: [],
    endowmentFundraiserPaymentsGroupedByYearMonth: [],
    endowmentFundraiserMemberPayments: [],
    endowmentFundraiserLinePayments: [],

    homecomingFundraiserPayments: [],
    homecomingFundraiserPaymentsGroupedByYearLine: [],
    homecomingFundraiserPaymentsGroupedByYearMonth: [],
    homecomingFundraiserMemberPayments: [],
    homecomingFundraiserLinePayments: [],
*/    
    subscriptionSettings: []
    },
    mutations: {
        setFundraiserTechassessmentSubscriptionStatus(state, payload){
            state.fundraiserTechassessmentSubscriptionStatus = payload
        },
        setListFundraiserTypes (state, payload){
            state.listFundraiserTypes = payload
        },   
        setSubscriptionSettings(state, payload){
            state.subscriptionSettings = payload
        },
        setFundraiserPayments (state, payload) {          
            if(state.fundraiserPayments===null){
                state.fundraiserPayments= new Object()
            }
            state.fundraiserPayments[payload.fundraiserid] = payload.data
        },
        setFundraiserPaymentsGroupedByYearLine (state, payload){
            if(state.fundraiserPaymentsGroupedByYearLine===null){
                state.fundraiserPaymentsGroupedByYearLine= new Object()
            }            
            state.fundraiserPaymentsGroupedByYearLine[payload.fundraiserid] = payload.data
        },
        setFundraiserPaymentsGroupedByYearMonth (state, payload){
            if(state.fundraiserPaymentsGroupedByYearMonth===null){
                state.fundraiserPaymentsGroupedByYearMonth= new Object()
            }                 
            state.fundraiserPaymentsGroupedByYearMonth[payload.fundraiserid] = payload.data
        },        
        setFundraiserMemberPayments (state, payload) {
            if(state.fundraiserMemberPayments===null){
                state.fundraiserMemberPayments= new Object()
            }                
            state.fundraiserMemberPayments[payload.fundraiserid] = payload.data
        },
        setFundraiserLinePayments (state, payload) {
            if(state.fundraiserLinePayments===null){
                state.fundraiserLinePayments= new Object()
            }               
            state.fundraiserLinePayments[payload.fundraiserid] = payload.data
        },

        setEndowmentFundraiserPayments (state, payload) {
            state.endowmentFundraiserPayments = payload
        },
        setEndowmentFundraiserPaymentsGroupedByYearLine (state, payload){
            state.endowmentFundraiserPaymentsGroupedByYearLine = payload
        },
        setEndowmentFundraiserPaymentsGroupedByYearMonth (state, payload){
            state.endowmentFundraiserPaymentsGroupedByYearMonth = payload
        },        
        setEndowmentFundraiserMemberPayments (state, payload) {
            state.endowmentFundraiserMemberPayments = payload
        },
        setEndowmentFundraiserLinePayments (state, payload) {
            state.endowmentFundraiserLinePayments = payload
        },



        setHomecomingFundraiserPayments (state, payload) {
            state.homecomingFundraiserPayments = payload
        },
        setHomecomingFundraiserPaymentsGroupedByYearLine (state, payload){
            
            state.homecomingFundraiserPaymentsGroupedByYearLine = payload
        },
        setHomecomingFundraiserPaymentsGroupedByYearMonth (state, payload){
            
            state.homecomingFundraiserPaymentsGroupedByYearMonth = payload
        },        
        setHomecomingFundraiserMemberPayments (state, payload) {
            state.homecomingFundraiserMemberPayments = payload
        },
        setHomecomingFundraiserLinePayments (state, payload) {
            state.homecomingFundraiserLinePayments = payload
        },

        setIsSyncedFundraiser (state, payload) {
            state.isSyncedFundraiser = payload
        },
        resetFundraiserState(state){
            state.isSyncedFundraiser=false
            state.fundraiserPayments= []
            state.fundraiserPaymentsGroupedByYearLine= []
            state.fundraiserPaymentsGroupedByYearMonth= []
            state.fundraiserMemberPayments= []
            state.fundraiserLinePayments= []
            state.fundraiserTechassessmentSubscriptionStatus = null,

            state.endowmentFundraiserPayments= []
            state.endowmentFundraiserPaymentsGroupedByYearLine= []
            state.endowmentFundraiserPaymentsGroupedByYearMonth= []
            state.endowmentFundraiserMemberPayments= []
            state.endowmentFundraiserLinePayments= []
            
            state.homecomingFundraiserPayments= []
            state.homecomingFundraiserPaymentsGroupedByYearLine= []
            state.homecomingFundraiserPaymentsGroupedByYearMonth= []
            state.homecomingFundraiserMemberPayments= []
            state.homecomingFundraiserLinePayments= []            
        }                             
    },
    actions: {
        clearError ({commit}) {
            commit('clearError')
        },
        initFundraiserSynch({commit}, payload) {

            var tmpOrg = payload.org
            var tmpChapter = payload.chapter
            var tmpMember = payload.member
            var tmpLineid = payload.lineid
            var tmpListFundraiserTypes = null 
            const settingsFundraisersDocRef = firebase.firestore().collection(tmpOrg + '/settings/' + tmpChapter ).doc('fundraisers')    
            settingsFundraisersDocRef
            .onSnapshot((singleDoc) => {
              if(singleDoc.exists) {
                  
                tmpListFundraiserTypes = singleDoc.data()
                console.log('tmpListFundraiserTypes',tmpListFundraiserTypes)
                commit('setListFundraiserTypes', tmpListFundraiserTypes)   

                }
            }, err=>{
                console.log('initFundraiserSynch err ', err)
            },()=>{
                console.log('initFundraiserSynch getsettings onshapshot done')
            })
           
            settingsFundraisersDocRef.get().then((doc)=> {
                if (doc.exists) {
                    tmpListFundraiserTypes = doc.data()

                    var fundraiserTypes = Object.keys(tmpListFundraiserTypes)
                    fundraiserTypes.forEach((f)=>{
                        var fundraiser = f
        
                          var docpath = tmpOrg + '/fundraisers/' + tmpChapter 
                          var docid = fundraiser
                          commit('setLoading', true)
                          const fundraiserPaymentsCollection = firebase.firestore().collection(docpath).doc(docid)                
                          fundraiserPaymentsCollection
                          .onSnapshot((singleDoc) => {
                            var tmpPaymentDocs=[]
                            if(singleDoc.exists ) {
                                tmpPaymentDocs = singleDoc.data().payments
                           
                                //tmpSetMethodName = 'set' + fundraiser.substring(0,1).toUpperCase() + fundraiser.substring(1) + 'FundraiserPayments'
                                //commit(tmpSetMethodName, tmpPaymentDocs)
                                commit('setFundraiserPayments', {fundraiserid: fundraiser, data: tmpPaymentDocs})                          
        
                                if(fundraiser==='techassessment'){ //special condition for techassessment
                                    //console.log('initFundraiserSynch entered techassessment condition')
                                    var statuses = tmpPaymentDocs.filter(p=>{return p.ispayment===false && p.userid===this.getters.member.userid})
                                    //console.log('initFundraiserSynch entered techassessment condition statuses', statuses)
                                    if(statuses && statuses.length>0){
                                        var lastStatus = statuses[statuses.length - 1]
                                        var rtn= new Object()
                                        if(lastStatus.transaction_type==="subscr_cancel"){
                                            rtn.isactive = false                
                                            rtn.statustype = "Subscription Cancelled"
                                        }else if(lastStatus.transaction_type==="subscr_eot"){
                                            rtn.isactive = false
                                            rtn.statustype = "Subscription Expired"
                                        }else if(lastStatus.transaction_type==="subscr_failed"){
                                            rtn.isactive = false
                                            rtn.statustype = "Subscription Payment Failed"
                                        }else if(lastStatus.transaction_type==="subscr_modify"){
                                            rtn.isactive = true
                                            rtn.statustype = "Subscription Active"
                                        }else if(lastStatus.transaction_type==="subscr_signup"){
                                            rtn.isactive = true
                                            rtn.statustype = "Subscription Active"
                                        }
                        
                                        rtn.amount = lastStatus.paypaldetails.mc_amount3
                                        rtn.statusdate = lastStatus.paymentdate
                                        rtn.subscr_id = lastStatus.subscr_id
                                        commit('setFundraiserTechassessmentSubscriptionStatus', rtn)  
                                    }                                    
                                }

                                var tmpSetMethodName = 'set' + fundraiser.substring(0,1).toUpperCase() + fundraiser.substring(1) + 'FundraiserPaymentsGroupedByYearLine'
                                if(tmpPaymentDocs && tmpPaymentDocs.length>0){

                                
                                    var tmpFundraiserPaymentsGroupedByYearLine  = d3.nest()
                                    .key(function(d) { return d.paymentdate.substring(0,4); }).sortKeys(d3.ascending)
                                    .key(function(d) { return d.lineid; }).sortKeys(d3.ascending)
                                    .rollup(function(leaves) { return {"count": leaves.length, "paymentsum": d3.sum(leaves, function(d) {return parseFloat(d.paymentamount);})} })
                                    .entries(tmpPaymentDocs)   
                                    var tmpObjFundraiserPaymentsGroupedByYearLine = new Object()
                                    tmpObjFundraiserPaymentsGroupedByYearLine.grandtotal = 0
                                    tmpObjFundraiserPaymentsGroupedByYearLine.yearly = new Array ()
                                    //var tmpArrFundraiserPaymentsGroupedByYearLine = new Array()
                                    tmpFundraiserPaymentsGroupedByYearLine.forEach(function(yeargroup) {
                                        var objYearGroup = new Object()
                                        objYearGroup.year = yeargroup.key
                                        objYearGroup.payments = new Array()
                                        objYearGroup.total = 0
                                        var yeargrouplines = new Array()
                                        if(yeargroup.values){
                                            yeargroup.values.forEach(function(yearlinegroup) {
            
                                                var shortLineId = yearlinegroup.key.substring(yearlinegroup.key.lastIndexOf('_', yearlinegroup.key.lastIndexOf('_')-1) +1)
                                                //objYearGroup[shortLineId] = yearlinegroup.value.paymentsum
                                                objYearGroup.payments.push({line: shortLineId,total: yearlinegroup.value.paymentsum })
                                                objYearGroup.total = objYearGroup.total + yearlinegroup.value.paymentsum
                                            })                          
                                            tmpObjFundraiserPaymentsGroupedByYearLine.yearly.push(objYearGroup)
                                        }
                                        tmpObjFundraiserPaymentsGroupedByYearLine.grandtotal = tmpObjFundraiserPaymentsGroupedByYearLine.grandtotal + objYearGroup.total
                                    });
            
                                    //commit(tmpSetMethodName, tmpObjFundraiserPaymentsGroupedByYearLine)     
                                    commit('setFundraiserPaymentsGroupedByYearLine', {fundraiserid: fundraiser, data: tmpObjFundraiserPaymentsGroupedByYearLine})      
                                    
            
            
            
            
                                    var tmpSetMethodName = 'set' + fundraiser.substring(0,1).toUpperCase() + fundraiser.substring(1) + 'FundraiserPaymentsGroupedByYearMonth'
            
                                    var tmpFundraiserPaymentsGroupedByYearMonth  = d3.nest()
                                    .key(function(d) { return d.paymentdate.substring(0,4); }).sortKeys(d3.ascending)
                                    .key(function(d) { return d.paymentdate.split('-')[1]; }).sortKeys(d3.ascending)
                                    .rollup(function(leaves) { return {"count": leaves.length, "paymentsum": d3.sum(leaves, function(d) {return parseFloat(d.paymentamount);})} })
                                    .entries(tmpPaymentDocs)   
                                    var tmpObjFundraiserPaymentsGroupedByYearMonth = new Object()
                                    tmpObjFundraiserPaymentsGroupedByYearMonth.grandtotal = 0
                                    tmpObjFundraiserPaymentsGroupedByYearMonth.yearly = new Array ()
                                    //var tmpArrFundraiserPaymentsGroupedByYearLine = new Array()
                                    tmpFundraiserPaymentsGroupedByYearMonth.forEach(function(yeargroup) {
                                        var objYearGroup = new Object()
                                        objYearGroup.year = yeargroup.key
                                        objYearGroup.payments = new Array()
                                        objYearGroup.total = 0
                                        if(yeargroup.values){
                                            yeargroup.values.forEach(function(yearmonthgroup) {
                                                objYearGroup.payments.push({month: yearmonthgroup.key,total: yearmonthgroup.value.paymentsum })
                                                objYearGroup.total = objYearGroup.total + yearmonthgroup.value.paymentsum
                                            })                          
                                            tmpObjFundraiserPaymentsGroupedByYearMonth.yearly.push(objYearGroup)
                                        }
                                        tmpObjFundraiserPaymentsGroupedByYearMonth.grandtotal = tmpObjFundraiserPaymentsGroupedByYearMonth.grandtotal + objYearGroup.total
                                    })
            
                                    //commit(tmpSetMethodName, tmpObjFundraiserPaymentsGroupedByYearMonth)  
                                    commit('setFundraiserPaymentsGroupedByYearMonth', {fundraiserid: fundraiser, data: tmpObjFundraiserPaymentsGroupedByYearMonth})
            
            
            
            
            
            
            

                                    
                                    
            
                                    var memberPaymentDocs = tmpPaymentDocs.filter(function(d){return d.lineid===tmpLineid && d.member===tmpMember})
                                    var linePaymentDocs = tmpPaymentDocs.filter(function(d){return d.lineid===tmpLineid})
                                    var tmpSetMethodNameMember = 'set' + fundraiser.substring(0,1).toUpperCase() + fundraiser.substring(1) + 'FundraiserMemberPayments'
            
                                    //commit(tmpSetMethodNameMember, memberPaymentDocs)  
                                    commit('setFundraiserMemberPayments', {fundraiserid: fundraiser, data: memberPaymentDocs})
            
                                    var tmpSetMethodNameLine = 'set' + fundraiser.substring(0,1).toUpperCase() + fundraiser.substring(1) + 'FundraiserLinePayments'
            
                                    //commit(tmpSetMethodNameLine, linePaymentDocs)      
                                    commit('setFundraiserLinePayments', {fundraiserid: fundraiser, data: linePaymentDocs})   
                                
                                }


                            }else{
                                console.log("document does not exist - " + docpath + '/' + docid )
                            }
                        })
                        commit('addSnapshotlistener', fundraiserPaymentsCollection)
                        commit('setLoading', false)
                        commit('setIsSyncedFundraiser', true)
                    })                            
                    commit('setLoading', false)
                } else {
                    // doc.data() will be undefined in this case
                    console.log("initFundraiserSynch No such document (fundraiser settings)")
                }
            }).catch(function(error) {
                console.log("Error getting document (fundraiser settings):", error)
            })

                         
            



            

         

        },
        getStorage({commit}){
            return firebase.storage()
        },
        onUpload ({commit}, {doUpload}){
          doUpload()
        },
        onDelete({commit}, {doDelete}){
          doDelete()
        }        
    },
    getters: {
        listFundraiserTypes (state){
            return state.listFundraiserTypes
          },   
        fundraiserPayments (state) {
            return state.fundraiserPayments
        },
        fundraiserPaymentsGroupedByYearLine (state){
            return state.fundraiserPaymentsGroupedByYearLine
        },
        fundraiserPaymentsGroupedByYearMonth (state){
            return state.fundraiserPaymentsGroupedByYearMonth
        },        
        fundraiserMemberPayments (state) {
            return state.fundraiserMemberPayments
        },
        fundraiserLinePayments (state) {
            return state.fundraiserLinePayments
        },

/*
        endowmentFundraiserPayments (state) {
            return state.endowmentFundraiserPayments
        },
        endowmentFundraiserPaymentsGroupedByYearLine (state){
            return state.endowmentFundraiserPaymentsGroupedByYearLine
        },
        endowmentFundraiserPaymentsGroupedByYearMonth (state){
            return state.endowmentFundraiserPaymentsGroupedByYearMonth
        },        
        endowmentFundraiserMemberPayments (state) {
            return state.endowmentFundraiserMemberPayments
        },
        endowmentFundraiserLinePayments (state) {
            return state.endowmentFundraiserLinePayments
        },

        homecomingFundraiserPayments (state) {
            return state.homecomingFundraiserPayments
        },
        homecomingFundraiserPaymentsGroupedByYearLine (state){
            return state.homecomingFundraiserPaymentsGroupedByYearLine
        },
        homecomingFundraiserPaymentsGroupedByYearMonth (state){
            return state.homecomingFundraiserPaymentsGroupedByYearMonth
        },        
        homecomingFundraiserMemberPayments (state) {
            return state.homecomingFundraiserMemberPayments
        },
        homecomingFundraiserLinePayments (state) {
            return state.homecomingFundraiserLinePayments
        },  
*/              
        isSyncedFundraiser(state){
            return state.isSyncedFundraiser
        },
        subscriptionSettings(state){
            return state.subscriptionSettings
        },      
        fundraiserTechassessmentSubscriptionStatus(state){
            return state.fundraiserTechassessmentSubscriptionStatus
        }                               
    }
  }